import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import ScrollAnimation from 'react-animate-on-scroll';
import './ContactBlock.scss';
import parse from 'html-react-parser';
import loadable from "@loadable/component";
import Buttons from "../Buttons/Buttons";
import { CONTACTFORM_PAGE_URL } from "@Components/common/site/constants";
const LeafletResultsMap = loadable(() => import("../map/leaflet/results"));

const ContactBlock = (props) => {
    const { ContactTitle, Content, Offices, Image, Ctas, id, ggfx_results } = props
    let hits = []
    Offices && Offices.map((item) => {
        hits.push({
            _geoloc: { lat: item.latitude, lng: item.longitude }
        })
    })

    return (
        <section className={`contact-wrapper-section ${props.image_align === "right" ? "right" : "left"} grey`} >
            <Container>
                <Row className={`d-flex align-items-center ${props.image_align === "right" ? "flex-row-reverse" : ""}`}>
                    <Col lg={6}>
                        <ScrollAnimation animateIn="animate__fadeIn" animateOnce delay={100} offset={10}>
                            <div className="content-wrapper">

                                <h2>{ContactTitle}</h2>
                                {Content && <>{parse(Content)}</>}
                                <div className="office-details">
                                    {Offices && Offices.map((item, n) => {
                                        return (
                                            <div className="office" key={n}>
                                                <div className="name">{item.Name}</div>
                                                <ul>
                                                    <li><i className="icon-phone"></i><a href={`tel:${item.Phone}`}>{item.Phone}</a></li>
                                                    <li><i className="icon-whatsapp"></i><a href={`https://wa.me/${item.Whatsapp}`}>WhatsApp</a></li>
                                                    <li><i className="icon-mail"></i><Link to={'/contact/'}>{item.Email}</Link></li>
                                                </ul>
                                            </div>
                                        )
                                    })}
                                </div>

                                <Buttons btns={Ctas} />
                            </div>

                        </ScrollAnimation>
                    </Col>
                    <Col lg={1}></Col>
                    <Col lg={5}>
                        {props.Offices && hits.length > 0 && <LeafletResultsMap hits={hits}
                            height={"350px"}
                        />}
                        {/* <ScrollAnimation animateIn="animate__slideInUp" animateOnce delay={100} offset={10}>{props.content && <ContentModule Content={props.content?.data?.content} />}</ScrollAnimation>
                        <ScrollAnimation animateIn="animate__slideInUp" animateOnce delay={200} offset={20}>{props.cta_link && <CTALink class="button button-secondary-outline" link={props.cta_link} title={props.cta_title} target_window={props.cta_link.target_window} />}</ScrollAnimation> */}


                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default ContactBlock;